export enum CampaignTypeEnum {
  PER_CHAPTER = 'PER_CHAPTER',
  WHOLE_STORY = 'WHOLE_STORY',
  FREE_READING = 'FREE_READING',
}

export const campaignTypeLabel: Record<CampaignTypeEnum, string> = {
  [CampaignTypeEnum.PER_CHAPTER]: 'โปรลดรายตอน',
  [CampaignTypeEnum.WHOLE_STORY]: 'โปรลดทั้งเรื่อง',
  [CampaignTypeEnum.FREE_READING]: 'โปรอ่านฟรี',
}
